module.exports = __webpack_public_path__ + "static/media/down-arrow.ec67fd95.svg";